import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import axios from 'axios';
import Card from '../components/Card';
import VideoSidebar from '../components/VideoSidebar';
import VerHistorias from '../components/VerHistorias';
import VistasPaginaBadge from '../components/VistasPaginaBadge';

function Home() {
  const [listings, setListings] = useState([]);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchName, setSearchName] = useState('');
  const [activeSearch, setActiveSearch] = useState('');
  const [showFilter, setShowFilter] = useState(false);
  const [filterRegion, setFilterRegion] = useState('');
  const [filterUbicacion, setFilterUbicacion] = useState('');
  const [filterCategoria, setFilterCategoria] = useState('');
  const [filterGenero, setFilterGenero] = useState('');
  const ITEMS_PER_PAGE = 12;
  const navigate = useNavigate();

  const [perfilesPremium, setPerfilesPremium] = useState([]);
  const [perfilesDestacado, setPerfilesDestacado] = useState([]);
  const [perfilPremiumSeleccionado, setPerfilPremiumSeleccionado] = useState(null);
  const [perfilDestacadoSeleccionado, setPerfilDestacadoSeleccionado] = useState(null);
  const scrollPremiumRef = useRef(null);
  const scrollDestacadoRef = useRef(null);

  useEffect(() => {
    //createFloatingParticles();
    axios.get(`${process.env.REACT_APP_PERFILES_URL}/get.php`)
      .then(res => {
        console.log('Respuesta completa:', res.data);
        
        // Si es string, intentar parsearlo como JSON
        let data = res.data;
        if (typeof data === 'string') {
            try {
                data = JSON.parse(data);
            } catch (e) {
                console.error('No se pudo parsear JSON:', e);
                data = [];
            }
        }
        
        // Asegurar que sea array
        if (Array.isArray(data)) {
            setListings(data);
        } else {
            setListings([]);
        }
      })
      .catch(err => console.error(err));
  }, []);

  // Verificar si el usuario tiene sesión activa
  useEffect(() => {
    const userToken = localStorage.getItem('userToken');
    setIsUserLoggedIn(!!userToken);
  }, []);

  const API_VIEWER = process.env.REACT_APP_HISTORIAS_VIEWER_URL;
  const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL;

  useEffect(() => {
    fetch(`${API_VIEWER}/get_historias_premium.php`)
      .then(res => res.json())
      .then(data => { if (data.success) setPerfilesPremium(data.data || []); })
      .catch(err => console.error('Error cargando historias premium:', err));
  }, [API_VIEWER]);

  useEffect(() => {
    fetch(`${API_VIEWER}/get_historias_destacadas.php`)
      .then(res => res.json())
      .then(data => { if (data.success) setPerfilesDestacado(data.data || []); })
      .catch(err => console.error('Error cargando historias destacadas:', err));
  }, [API_VIEWER]);

  // Obtener información del usuario logueado
  const userName = localStorage.getItem('userName');
  const userEmail = localStorage.getItem('userEmail');

  // Valores únicos para dropdowns (desde datos ya cargados)
  const uniqueRegions = [...new Set(listings.map(i => i.region).filter(Boolean))];
  const uniqueUbicaciones = [...new Set(
    listings
      .filter(i => filterRegion === '' || i.region === filterRegion)
      .map(i => i.ubicacion)
      .filter(Boolean)
  )];

  // Filtrado client-side combinado
const filteredListings = listings.filter(item => {
    const nameMatch = activeSearch === '' || item.nombre.toLowerCase().includes(activeSearch.toLowerCase());
    const regionMatch = filterRegion === '' || item.region === filterRegion;
    const ubicacionMatch = filterUbicacion === '' || item.ubicacion === filterUbicacion;
    const categoriaMatch = filterCategoria === '' || (item.categoria || '').toLowerCase() === filterCategoria.toLowerCase();
    const generoMatch = filterGenero === '' || (item.genero || '').toLowerCase() === filterGenero.toLowerCase();
    return nameMatch && regionMatch && ubicacionMatch && categoriaMatch && generoMatch;
  });

  const handleBusqueda = () => {
    setActiveSearch(searchName);
    setCurrentPage(1);
  };

  const handleFilterToggle = () => {
    setShowFilter(prev => !prev);
  };

  return (
    <div className="home-container">
      {/* Logo superior */}
      <div className="logo-container">
        <img src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`} alt="Ulalaaa Logo" className="main-logo" />
      </div>

      <VistasPaginaBadge pagina="home" />

      {/* Banner de sesión de usuario (solo si está logueado) */}
      {isUserLoggedIn && (
        <div className="user-session-banner">
          <div className="session-info">
            <i className="fas fa-user-circle"></i>
            <div className="session-text">
              <span className="session-label">Inicio sesión:</span>
              <span className="session-user">{userName || userEmail}</span>
            </div>
          </div>
          <button 
            className="btn-mi-perfil"
            onClick={() => {
              navigate('/sesion_viewer');
            }}
          >
            Mi Perfil
          </button>
          <button 
            className="btn-cerrar-sesion"
            onClick={() => {
              // Limpiar localStorage
              localStorage.removeItem('userToken');
              localStorage.removeItem('userId');
              localStorage.removeItem('userName');
              localStorage.removeItem('userEmail');
              localStorage.removeItem('returnToProfile');
        
              // Actualizar estado
              setIsUserLoggedIn(false);
            }}
          >
            Cerrar Sesión
          </button>
        </div>
      )}

{/* Banner con Historias */}
      <div className="home-historias-banner">
        <div className="home-historias-title">HISTORIAS</div>

        {/* Fila Premium */}
        {perfilesPremium.length > 0 && (
          <>
            <div className="home-hist-subtitulo home-hist-subtitulo-premium">HISTORIAS PREMIUM</div>
            <div className="home-hist-scroll-wrapper" ref={scrollPremiumRef}>
              <div className="home-hist-circulos">
                {perfilesPremium.map(perfil => (
                  <div
                    key={perfil.usuario_id}
                    className="home-hist-circulo-wrapper"
                    onClick={() => setPerfilPremiumSeleccionado(perfil)}
                  >
                    <div className="home-hist-circulo-anillo home-hist-anillo-premium">
                      <div className="home-hist-circulo-inner">
                        {perfil.fotos ? (
                          <img
                            src={`${UPLOADS_URL}/ID_${perfil.usuario_id}/${perfil.fotos}?v=${perfil.usuario_id}`}
                            alt={perfil.nombre}
                            className="home-hist-circulo-img"
                          />
                        ) : (
                          <div className="home-hist-circulo-vacio">
                            <span>{perfil.nombre?.charAt(0)}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <span className="home-hist-nombre">{perfil.nombre}</span>
                  </div>
                ))}
              </div>
              {perfilesPremium.length > 6 && (
                <button
                  className="home-hist-flecha"
                  onClick={() => scrollPremiumRef.current?.scrollBy({ left: 200, behavior: 'smooth' })}
                >➜</button>
              )}
            </div>
          </>
        )}

        {/* Fila Destacado */}
        {perfilesDestacado.length > 0 && (
          <>
            <div className="home-hist-subtitulo home-hist-subtitulo-destacado">HISTORIAS DESTACADAS</div>
            <div className="home-hist-scroll-wrapper" ref={scrollDestacadoRef}>
              <div className="home-hist-circulos">
                {perfilesDestacado.map(perfil => (
                  <div
                    key={perfil.usuario_id}
                    className="home-hist-circulo-wrapper"
                    onClick={() => setPerfilDestacadoSeleccionado(perfil)}
                  >
                    <div className="home-hist-circulo-anillo home-hist-anillo-destacado">
                      <div className="home-hist-circulo-inner">
                        {perfil.fotos ? (
                          <img
                            src={`${UPLOADS_URL}/ID_${perfil.usuario_id}/${perfil.fotos}?v=${perfil.usuario_id}`}
                            alt={perfil.nombre}
                            className="home-hist-circulo-img"
                          />
                        ) : (
                          <div className="home-hist-circulo-vacio home-hist-circulo-vacio-dest">
                            <span>{perfil.nombre?.charAt(0)}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <span className="home-hist-nombre">{perfil.nombre}</span>
                  </div>
                ))}
              </div>
              {perfilesDestacado.length > 6 && (
                <button
                  className="home-hist-flecha"
                  onClick={() => scrollDestacadoRef.current?.scrollBy({ left: 200, behavior: 'smooth' })}
                >➜</button>
              )}
            </div>
          </>
        )}
      </div>

      {/* Botón fuera del banner */}
      <div className="home-publicar-wrapper">
        <a href="/acceso-publicar" className="publicar-aviso-btn home-publicar-btn">
          <i className="fas fa-plus-circle"></i>
          <span className="publicar-aviso-textos">
            <span>PUBLICA TU AVISO - REGISTRATE</span>
            <span className="publicar-acceso-text">Acceso a tu cuenta</span>
          </span>
        </a>
      </div>

      {/* Modales VerHistorias */}
      {perfilPremiumSeleccionado && (
        <VerHistorias
          usuarioId={perfilPremiumSeleccionado.usuario_id}
          nombrePerfil={perfilPremiumSeleccionado.nombre}
          fotoPerfil={
            perfilPremiumSeleccionado.fotos
              ? `${UPLOADS_URL}/ID_${perfilPremiumSeleccionado.usuario_id}/${perfilPremiumSeleccionado.fotos}`
              : null
          }
          esCreador={false}
          onClose={() => setPerfilPremiumSeleccionado(null)}
        />
      )}
      {perfilDestacadoSeleccionado && (
        <VerHistorias
          usuarioId={perfilDestacadoSeleccionado.usuario_id}
          nombrePerfil={perfilDestacadoSeleccionado.nombre}
          fotoPerfil={
            perfilDestacadoSeleccionado.fotos
              ? `${UPLOADS_URL}/ID_${perfilDestacadoSeleccionado.usuario_id}/${perfilDestacadoSeleccionado.fotos}`
              : null
          }
          esCreador={false}
          onClose={() => setPerfilDestacadoSeleccionado(null)}
        />
      )}

      <div className="home-content">
<div className='left-column'>

          {/* Filtros Categoría y Género */}
          <div className="home-catgen-container">
            <div className="home-catgen-row">
              <span className="home-catgen-label">Categoría</span>
              <div className="home-catgen-btns">
                {['Escort', 'Masajes', 'Venta contenido'].map(cat => (
                  <button
                    key={cat}
                    className={`home-catgen-btn${filterCategoria === cat ? ' home-catgen-btn-activo' : ''}`}
                    onClick={() => {
                      setFilterCategoria(prev => prev === cat ? '' : cat);
                      setCurrentPage(1);
                    }}
                  >{cat}</button>
                ))}
              </div>
            </div>
            <div className="home-catgen-row">
              <span className="home-catgen-label">Género</span>
              <div className="home-catgen-btns">
                {[{ label: 'Mujer', value: 'mujer' }, { label: 'Hombre', value: 'hombre' }, { label: 'Travesti', value: 'travesti' }].map(g => (
                  <button
                    key={g.value}
                    className={`home-catgen-btn${filterGenero === g.value ? ' home-catgen-btn-activo' : ''}`}
                    onClick={() => {
                      setFilterGenero(prev => prev === g.value ? '' : g.value);
                      setCurrentPage(1);
                    }}
                  >{g.label}</button>
                ))}
              </div>
            </div>
          </div>

          {/* Barra de búsqueda y filtro */}
          <div className="search-bar-container">
            <div className="search-bar-row">
              <button className="search-btn" onClick={handleBusqueda}>BUSQUEDA</button>
              <input
                className="search-input"
                type="text"
                placeholder="Nombre"
                value={searchName}
                onChange={e => setSearchName(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleBusqueda(); }}
              />
              <button className="filter-btn" onClick={handleFilterToggle}>FILTRO</button>
            </div>

            {showFilter && (
              <div className="filter-panel">
                <div className="filter-row">
                  <span className="filter-label">Region</span>
                  <select
                    className="filter-select"
                    value={filterRegion}
                    onChange={e => { setFilterRegion(e.target.value); setFilterUbicacion(''); setCurrentPage(1); }}
                  >
                    <option value="">Selecciona</option>
                    {uniqueRegions.map(r => (
                      <option key={r} value={r}>{r}</option>
                    ))}
                  </select>
                </div>
                <div className="filter-row">
                  <span className="filter-label">Ubicacion</span>
                  <select
                    className="filter-select"
                    value={filterUbicacion}
                    onChange={e => { setFilterUbicacion(e.target.value); setCurrentPage(1); }}
                  >
                    <option value="">Selecciona</option>
                    {uniqueUbicaciones.map(u => (
                      <option key={u} value={u}>{u}</option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>

          {(() => {
            const premiumList = filteredListings.filter(item => item.categoria_plan === 'Premium');
            const destacadoList = filteredListings.filter(item => item.categoria_plan === 'Destacado');
            const totalPages = Math.max(
              Math.ceil(premiumList.length / ITEMS_PER_PAGE),
              Math.ceil(destacadoList.length / ITEMS_PER_PAGE),
              1
            );
            const premiumPage = premiumList.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
            const destacadoPage = destacadoList.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

            return (
              <>
                {/* Sección PREMIUM */}
                {premiumPage.length > 0 && (
                  <>
                    <div className="section-title section-title-premium">PREMIUM</div>
                    <div className="cards-container">
                      {premiumPage.map(item => (
                        <Card key={item.id} data={item} />
                      ))}
                    </div>
                  </>
                )}

                {/* Sección DESTACADO */}
                {destacadoPage.length > 0 && (
                  <>
                    <div className="section-title section-title-destacado">DESTACADO</div>
                    <div className="cards-container">
                      {destacadoPage.map(item => (
                        <Card key={item.id} data={item} />
                      ))}
                    </div>
                  </>
                )}

                {/* Sin resultados */}
                {premiumPage.length === 0 && destacadoPage.length === 0 && (activeSearch !== '' || filterRegion !== '' || filterUbicacion !== '' || filterCategoria !== '' || filterGenero !== '') && (
                  <div className="no-results-msg">PUBLICACION NO ENCONTRADA</div>
                )}

                {/* Paginación */}
                {totalPages > 1 && (
                  <div className="pagination-controls">
                    <button
                      className="pagination-btn"
                      onClick={() => setCurrentPage(p => p - 1)}
                      disabled={currentPage === 1}
                    >
                      ← Anterior
                    </button>
                    <span className="pagination-info">{currentPage} / {totalPages}</span>
                    <button
                      className="pagination-btn"
                      onClick={() => setCurrentPage(p => p + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Siguiente →
                    </button>
                  </div>
                )}
              </>
            );
          })()}
        </div>
<div className="right-column">
          <VideoSidebar />
        </div>
      </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
<a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
<div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>

    </div>
  );
}

export default Home;